import React, { useState} from "react";
import { Link } from "react-router-dom";
import "../../styles/NavBar.css";

export default function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isFixed, setIsFixed] = useState(false);


  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);


  return (
    <header className={`header ${isFixed ? "fixed" : ""}`}>
      <div className="navContainer">
        <a href="./" className="logo">
          <img
            src="https://nsykpvjwslvdnfbknhmm.supabase.co/storage/v1/object/public/church/Files/Logo.png"
            alt="Logo Agape"
          />
        </a>

        {/* Botão Hamburger */}
        <div className={`hamburger ${menuOpen ? "active" : ""}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        {/* Menu principal */}
        <nav className={`navMenu ${menuOpen ? "open" : ""}`}>
          <ul className="navLinks">
            <li><Link to="/Simbolos-Cristaos">Símbolos Cristãos</Link></li>
            <li><Link to="/Sacramentos">Sacramentos</Link></li>
            <li><Link to="/Pascoa">Páscoa</Link></li>
            <li><Link to="/Advento">Advento</Link></li>
            <li><Link to="/Simbolos-Espirito">Símbolos do Espírito Santo</Link></li>
            <li><Link to="/Dons-Espirito">Dons do Espírito Santo</Link></li>
            <li><Link to="/Mandamentos">10 Mandamentos</Link></li>
            <li><Link to="/SJ">São José</Link></li>
            <li><Link to="/NSA">Nossa Senhora</Link></li>
            <li><Link to="/Sagrada-Face">Sagrada Face</Link></li>

            {/* Dropdown */}
            <li className="dropdown">
              <button className="dropdownBtn" onClick={toggleDropdown}>
                Santos & Espiritualidade ▾
              </button>
              <ul className={`dropdownMenu ${dropdownOpen ? "show" : ""}`}>

                <li><Link to="/Sagrados-Coracoes">Corações</Link></li>
                <li><Link to="/Gestos">Gestos</Link></li>
                <li><Link to="/Dizimo">Dízimo</Link></li>
                <li><Link to="/7-Pai-Nosso">7 Pai Nossos</Link></li>
                <li><Link to="/15-Oracoes-Santa-Brigida">15 Orações</Link></li>
                <li><Link to="/Reliquias">Relíquias</Link></li>
              </ul>
            </li>

            <li><Link to="/Hierarquia-Angelical">Hierarquia Angelical</Link></li>
            <li><Link to="/Anjo-Da-Guarda">Anjo da Guarda</Link></li>
            <li><Link to="/Tercos">Terços</Link></li>
            <li><Link to="/Purgatorio">Purgatório</Link></li>            
          </ul>
        </nav>
      </div>
    </header>
  );
}